module.exports = __webpack_public_path__ + "img/row-img2.f6003a5d.png";